<template>
  <div class="page"></div>
</template>

<style scoped lang="scss"></style>
